import { render, staticRenderFns } from "./test2CustomView.vue?vue&type=template&id=5a891cec&scoped=true"
import script from "./test2CustomView.vue?vue&type=script&lang=js"
export * from "./test2CustomView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a891cec",
  null
  
)

export default component.exports